import { ArrowLeft, ArrowRight } from "lucide-react";
import React, { useEffect, useRef, useState } from "react";
import TooltipWrapper from "../TooltipWrapper";
import { useCaptureEvent } from "../../../hooks/useCaptureEvent";
import Image from "../../Tags/Image";
// import { useCaptureEvent } from "../../hooks/useCaptureEvent";

export default function HeadCount({ data = {}, employee_count = {} }) {
  const captureEvent = useCaptureEvent();
  console.log("datadata,", data);
  const [value, setValue] = useState("month");
  useEffect(() => {
    console.log(value);
  }, [value]);

  const sortByCount = (arr) => {
    console.log(arr);
    let sortedArray = arr.sort((a, b) => b.count - a.count);
    console.log("sortedArray", sortedArray);
    return sortedArray;
  };
  const calculatePercentage = (a, b) => {
    const percentage = (b / a) * 100;
    const relativeValue = (percentage / 100) * 100;
    return relativeValue;
  };

  const truncateString = (str, maxLength) => {
    if (str.length > maxLength) {
      return str.slice(0, maxLength - 3) + "...";
    }
    return str;
  };

  const BarChart = ({ data, heading = "", width = "" }) => (
    <div className={`p-6 border border-gray-200 bg-gray-50 rounded-xl ${width ? width : "flex-1"}`}>
      <h2 className="text-base text-gray-900 font-semibold mb-6">{heading}</h2>
      {data &&
        data.length > 0 &&
        sortByCount(data).map((item) => (
          <div className="mt-6">
            <p className="text-foreground text-sm mb-2 flex items-center">
              <span className="rounded-lg py-1 px-1.5 bg-gray-100 dark:bg-gray-200 dark:text-white mr-2">
                {item?.count}
              </span>{" "}
              <span>
                <TooltipWrapper content={item?.name}>{truncateString(item?.name, 33)}</TooltipWrapper>
              </span>
            </p>
            <div
              className="h-6 rounded bg-brand-500"
              style={{
                width: `${calculatePercentage(data[0]?.count, item?.count)}%`,
              }}
            ></div>
          </div>
        ))}
    </div>
  );

  const scrollRef = useRef(null);

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: -399, // Adjust the scroll amount as needed
        behavior: "smooth", // Add smooth scrolling
      });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: 399, // Adjust the scroll amount as needed
        behavior: "smooth", // Add smooth scrolling
      });
    }
  };

  const [currentValuePercent, setCurrentValuePercent] = useState(null);
  const [currentValueAbsolute, setCurrentValueAbsolute] = useState(null);
  const [currentType, setCurrentType] = useState(null);

  useEffect(() => {
    if (data?.mom_percent) {
      setCurrentValuePercent(data?.mom_percent);
      setCurrentValueAbsolute(data?.mom_absolute);
      setCurrentType("month");
    } else if (data?.qoq_percent) {
      setCurrentValuePercent(data?.qoq_percent);
      setCurrentValueAbsolute(data?.qoq_absolute);
      setCurrentType("quarter");
    } else if (data?.yoy_percent) {
      setCurrentValuePercent(data?.yoy_percent);
      setCurrentValueAbsolute(data?.yoy_absolute);
      setCurrentType("year");
    } else {
      setCurrentValuePercent(null);
      setCurrentValueAbsolute(null);
      setCurrentType(null);
    }
  }, [data]);

  const changeType = (type) => {
    if (type === "month" && data?.mom_percent) {
      setCurrentValuePercent(data?.mom_percent);
      setCurrentValueAbsolute(data?.mom_absolute);
      setCurrentType("month");
    } else if (type === "quarter" && data?.qoq_percent) {
      setCurrentValuePercent(data?.qoq_percent);
      setCurrentValueAbsolute(data?.qoq_absolute);
      setCurrentType("quarter");
    } else if (type === "year" && data?.yoy_percent) {
      setCurrentValuePercent(data?.yoy_percent);
      setCurrentValueAbsolute(data?.yoy_absolute);
      setCurrentType("year");
    } else {
      setCurrentValuePercent(null);
      setCurrentValueAbsolute(null);
      setCurrentType(null);
    }
  };

  return (
    <>
      <div className="flex mb-2 space-x-4 px-4 -mx-4 mobile:block mobile:mx-0 mobile:space-x-0 mobile:px-0">
        <div className="w-6/12 mobile:w-full mobile:mb-3">
          <div className="border rounded-[14px] overflow-hidden border-input  bg-background relative p-4 py-5">
            <Image src="/images/ext/companyinfo/users-purple.svg" className="mb-6 no-invert" />
            <p className="text-sm font-normal text-text-700 mb-2">Total Employees</p>
            <p className="text-4xl font-bold text-gray-900">
              {data && data?.total ? (
                data?.total
              ) : (
                <>
                  {employee_count?.exact ? (
                    employee_count?.exact
                  ) : (
                    <>
                      {employee_count?.range?.min}{" "}
                      {employee_count?.range?.max && `- ${employee_count?.range?.max}`}
                    </>
                  )}
                </>
              )}
            </p>
          </div>
        </div>
        <div className="w-6/12 mobile:w-full">
          <div className="border rounded-[14px] overflow-hidden border-input  bg-background relative p-4">
            <div className="flex justify-between w-full space-x-4">
              <p className="text-base font-bold text-text-700 w-7/12">
                <span className="text-sm font-normal">Employee count growth</span>
                {typeof currentValueAbsolute === "number" && currentValueAbsolute ? (
                  <p className="text-2xl text-gray-900 mt-3">
                    <span className="inline-block">
                      {currentValueAbsolute < 0 ? "" : "+"}
                      {currentValueAbsolute}
                    </span>
                    <span className="inline-flex space-x-1 ml-3 relative -top-1.5">
                      <Image
                        className="no-invert"
                        src={
                          currentValuePercent < 0
                            ? "/images/ext/companyinfo/downtrend.svg"
                            : "/images/ext/companyinfo/uptrend.svg"
                        }
                      />
                      <span
                        className={`${currentValuePercent < 0 ? "text-error-600" : "text-success-500"} text-sm`}
                      >
                        {currentValuePercent}%
                      </span>
                    </span>
                  </p>
                ) : (
                  <p className="text-2xl text-gray-900 mt-3">&nbsp;</p>
                )}
              </p>
              <select
                value={currentType}
                defaultValue={currentType}
                className="text-sm font-normal flex h-9 w-5/12 rounded-md border border-input bg-transparent px-2 py-1 shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                onChange={(e) => {
                  setValue(e.target.value);
                  changeType(e.target.value);
                  captureEvent("EXC_CompanyPeople_EmployeeCountGrowthBtn", {
                    filter_type: `vs Last ${e.target.value}`,
                  });
                }}
              >
                <option value="month">vs Last month</option>
                <option value="quarter">vs Last quarter</option>
                <option value="year">vs Last year</option>
              </select>
            </div>
            {currentValuePercent ? (
              <Image
                className="w-full no-invert"
                src={
                  currentValuePercent < 0
                    ? "/images/ext/companyinfo/downtrend-chart.svg"
                    : "/images/ext/companyinfo/uptrend-chart.svg"
                }
              />
            ) : (
              <Image className="w-full no-invert" src={"/images/ext/companyinfo/notrend-chart.svg"} />
            )}
          </div>
        </div>
      </div>
      <div className="border rounded-[14px] overflow-hidden border-border  bg-background relative mt-4  py-4 pt-2 px-4">
        <div className="flex justify-between mb-4 mt-2">
          <h3 className="text-gray-900  font-semibold text-[16px]">People Distribution</h3>
          <div className="inline-flex rounded-lg overflow-hidden border bg-background items-center leading-none whitespace-normal">
            <span className="border-r p-1.5 cursor-pointer" onClick={scrollLeft}>
              <ArrowLeft width={18} height={18} />
            </span>
            <span className="p-1.5 cursor-pointer" onClick={scrollRight}>
              <ArrowRight width={18} height={18} />
            </span>
          </div>
        </div>
        <div
          className="flex overflow-hidden overflow-x-scroll space-x-4 bar__chart__scroll__parent items-start"
          ref={scrollRef}
        >
          {data?.by_function && data?.by_function.length > 0 && (
            <BarChart data={data?.by_function} heading="Department" width="w-[383px] flex-1 min-w-[383px]" />
          )}
          {data?.by_alma_mater && data?.by_alma_mater.length > 0 && (
            <BarChart
              data={data?.by_alma_mater}
              heading="Alma mater"
              width="w-[383px] flex-1 min-w-[383px]"
            />
          )}
          {data?.by_field_of_study && data?.by_field_of_study.length > 0 && (
            <BarChart
              data={data?.by_field_of_study}
              heading="Field of Study"
              width="w-[383px] flex-1 min-w-[383px]"
            />
          )}
          {data?.by_region && data?.by_region.length > 0 && (
            <BarChart data={data?.by_region} heading="Location" width="w-[383px] flex-1 min-w-[383px]" />
          )}
          {data?.by_skill && data?.by_skill.length > 0 && (
            <BarChart data={data?.by_skill} heading="Skills" width="w-[383px] flex-1 min-w-[383px]" />
          )}
        </div>
      </div>
    </>
  );
}
